<template>
    <header class="header-global portulans-nav">
        <base-nav type="white" transparent effect="light" expand>
            <a target="_blank" href="https://descartesinstitute.net/" slot="brand" class="navbar-brand mr-lg-5">
                  <img src="../../public/img/brand/descartes_institute.png" alt="logo">
            </a>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a target="_blank" href="https://descartesinstitute.net/">
                        <img src="../../public/img/brand/descartes_institute.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center navbar-dark descartes">
              <li class="nav-item">
                <router-link to="/2023/" title="Home Page"><a class="nav-link nav-link-icon" href="#" rel="noopener">
                  Home
                </a></router-link>
              </li>
              <li class="nav-item">
                <router-link to="/2023/about" title="About Page"><a class="nav-link nav-link-icon" href="#" rel="noopener" data-toggle="tooltip">
                  About FREI
                </a></router-link>
              </li>
              <li class="nav-item">
                <router-link to="/2023/report" title="Report Page"><a class="nav-link nav-link-icon" href="#" rel="noopener" data-toggle="tooltip">
                  Countries
                </a></router-link>
              </li>
              <li class="nav-item">
                <router-link to="/2023/what-ifs" title="Talent Positioning System Page"><a class="nav-link nav-link-icon" href="#" rel="noopener" data-toggle="tooltip">
                  What Ifs
                </a></router-link>
              </li>
              <li class="nav-item">
                <router-link to="/2023/contact-us" title="Talent Positioning System Page"><a class="nav-link nav-link-icon" href="#" rel="noopener" data-toggle="tooltip">
                  Get in Touch
                </a></router-link>
              </li>
            </ul>

        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components-2023/BaseNav";
import CloseButton from "@/components-2023/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton
  }
};
</script>
<style>
</style>
